import React from 'react';

import './allright.css';

function Allright() {
    return (
      <div className="allright window__allright" id = 'allright'>
				<p className="allright__foot">Помощь и обратноя связь &nbsp; &nbsp; &nbsp; Реклама &nbsp; &nbsp; &nbsp;  &#169; 2001-2018, Яндекс</p>
		</div>
    );
}

export default Allright;